import React from 'react'

import { FileNameToolTip } from './FileNameToolTip'
import {
  BackToTheFront,
  CenterButtons,
  Content,
  FileListItem,
  IconButton,
  List,
  MessageBodyCenter,
  MessageBodyCenterFailure,
  MessageBodyCenterSmall,
  MessageBodyListBody,
  MessageBodyListHeaderBold,
  MessageBold,
  MessageListBodyCenterBold
} from './styled-components'
import type { FileStatus, UIConfigType } from './types'

type FailedPageProps = {
  uiConfig: UIConfigType
  claimNumber: string
  unsupportedErrors: FileStatus[]
  networkErrors: FileStatus[]
  lostConnectionErrors: FileStatus[]
  failureHref: string
  failureSvgColor: string
  textColor: string
  onBackToUploadPage(): (event: React.SyntheticEvent) => void
  onFindClaimClick(event: React.SyntheticEvent): void
}

const FailedPage = (props: FailedPageProps) => {
  const {
    uiConfig,
    claimNumber,
    textColor,
    unsupportedErrors,
    networkErrors,
    lostConnectionErrors,
    failureHref,
    failureSvgColor,
    onBackToUploadPage,
    onFindClaimClick
  } = props
  return (
    <Content>
      {uiConfig.icon}
      <MessageBodyCenterFailure id="failed-message">
        {uiConfig.info.pre}
        <MessageBold>
          {claimNumber.toUpperCase()}
        </MessageBold>
        {uiConfig.info.post}
      </MessageBodyCenterFailure>
      <MessageBodyCenterSmall>
        Please note: larger files may take longer to process.
      </MessageBodyCenterSmall>
      {
        <List color={textColor} background="#FFFFFF">
          <MessageListBodyCenterBold>Files for upload</MessageListBodyCenterBold>
          <MessageBodyListHeaderBold> FAILED UPLOADS </MessageBodyListHeaderBold>
          <MessageBodyListBody>
            <FileListItem id="unsupported-list">
                {unsupportedErrors.map((s, i) =>
                  <FileNameToolTip
                    key={i}
                    index={i}
                    fileName={s.fileName}
                    fileSize={s.fileSize}
                    color={textColor}
                    href={failureHref}
                    svgColor={failureSvgColor}
                  />
                )}
            </FileListItem>
            <FileListItem id="network-list">
              {networkErrors.map((s, i) =>
                <FileNameToolTip
                  key={i}
                  index={i}
                  fileName={s.fileName}
                  fileSize={s.fileSize}
                  color={textColor}
                  href={failureHref}
                  svgColor={failureSvgColor}
                />
              )}
            </FileListItem>
            <FileListItem id="lost-connection-list">
                {lostConnectionErrors.map((s, i) =>
                  <FileNameToolTip
                    key={i}
                    index={i}
                    fileName={s.fileName}
                    fileSize={s.fileSize}
                    color={textColor}
                    href={failureHref}
                    svgColor={failureSvgColor}
                  />
                )}
            </FileListItem>
          </MessageBodyListBody>
        </List>
      }
      <br></br>
      <MessageBodyCenter>
        Retry failed files for <MessageBold>
          {claimNumber.toUpperCase()}
        </MessageBold> or start a new upload.
      </MessageBodyCenter>
      <CenterButtons>
        <IconButton onClick={onBackToUploadPage()}>
          {uiConfig.backButtonText}
        </IconButton>
        <BackToTheFront onClick={onFindClaimClick} href="#">NEW UPLOAD</BackToTheFront>
      </CenterButtons>
    </Content>
  )
}

export { FailedPage }
